import { createContext } from "react";

const UserDetails = createContext();

export default UserDetails;
